import { cn } from '@ui-kit/utils';
import type { ComponentProps } from 'react';

const ButtonLink = ({ className, ...props }: ComponentProps<'button'>) => (
  <button type="button" className={cn('link', className)} {...props} />
);

export default ButtonLink;
